
<template>
  <div class="swiper-box">
    <img class="banner" :src="imgList[0].img" style="width: 100%;z-index: -1;">
    <mt-swipe :auto="4000" v-if="imgList.length>0">
      <!--<mt-swipe-item v-for="list in imgList">1</mt-swipe-item>-->
      <mt-swipe-item v-for="(list,index) in imgList" :key="index"><img :src="list.img"><a class="tap-highlight" :href="list.url"></a></mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>

export default {
  name: 'swiper',
  props: ['imgList', 'height', 'location'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    // onLoadBanner () {
    //   console.log('onload', parseFloat(window.getComputedStyle(document.getElementsByClassName('banner')[0]).height))
    //   this.$emit('getBannerH', parseFloat(window.getComputedStyle(document.getElementsByClassName('banner')[0]).height))
    // }
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/px2rem.scss";
  .swiper-box{
    z-index: 2;
    width: 100%;
    position: relative
  }
  .swiper-box .mint-swipe{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .swiper-box .mint-swipe-indicators{
    bottom: rem(3);
  }
  .swiper-box .mint-swipe-indicator{
    width: rem(5);
    height: rem(5);
    margin: 0 rem(4);
    opacity: 0.3;
  }
  .swiper-box img{
    width: 100%;
    display: block;
  }
  .mint-swipe-item img{
    position: absolute;
    top: 0;
    left: 0;
  }
  a{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/swiper.vue